













































import { Component, Vue } from 'vue-property-decorator';
import { IServiceCreate } from '@/interfaces';
import { dispatchCreateService, dispatchGetServices } from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
  },
})
export default class CreateService extends Vue {
  public valid = false;
  public name: string = '';
  public proxyHost: string | null = null;
  public proxyReportHost: string | null = null;
  public proxyCallBackUrl: string | null = null;
  public passBadMessages: boolean = false;
  public ignoreUserBans: boolean = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetServices(this.$store);
    this.reset();
  }

  public reset() {
    this.name = '';
    this.proxyHost = null;
    this.proxyReportHost = null;
    this.proxyCallBackUrl = null;
    this.passBadMessages = false;
    this.ignoreUserBans = false;
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updatedService: IServiceCreate = {
        name: this.name,
        proxy_host: this.proxyHost,
        proxy_report_host: this.proxyReportHost,
        proxy_callback_url: this.proxyCallBackUrl,
        pass_bad_messages: this.passBadMessages,
        ignore_user_bans: this.ignoreUserBans,
      };
      const result = await dispatchCreateService(this.$store, updatedService);
      if (result) {
        this.$router.push('/main/admin/services');
      }
    }
  }
}
